import { useParams } from 'react-router-dom'
import { useGetServiceDetailsList } from '@/modules/Users/queries/PatientQueries/Patient.queries'
import { useModalStore } from '@/store/useModal'

const useRefundDetailsModal = () => {
  const attendanceId = useParams()
  const { modalOpen, closeModal } = useModalStore()
  const { serviceDetailsList } = useGetServiceDetailsList(attendanceId.userId)

  const refundDetailsList = serviceDetailsList?.patientPayment

  return {
    modalOpen,
    closeModal,
    refundDetailsList,
  }
}

export default useRefundDetailsModal
